// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"scrollable--1JiR4","scrollable-content":"scrollable-content--3X_Kn","scrollableContent":"scrollable-content--3X_Kn"};